import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ApiService } from 'src/app/_services/api.service';
import { News } from 'src/app/_models/news';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';

@Component({
    selector: 'app-newsroom',
    templateUrl: './newsroom.component.html',
    styleUrls: ['./newsroom.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewsroomComponent implements OnInit, AfterViewInit {
  newsRecent: News[];
  returnNewsRecent: News[];
  newsPressRelease: News[];
  returnNewsPress: News[];
  showBoundaryLinks = true;
   showDirectionLinks = true;
  constructor(private apiService: ApiService, private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id || null;
  }

  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  id = 0;

  selectTab(tabId: number) {
    const tab = this.staticTabs?.tabs[tabId];
    if (tab) {
      tab.active = true;
    }
  }

  ngAfterViewInit() {
    if (this.id !== null) {
      this.selectTab(this.id - 1);
    }
  }

  pageChanged(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.returnNewsRecent = this.newsRecent.slice(startItem, endItem);
 }
  pageChangedPress(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.returnNewsPress = this.newsPressRelease.slice(startItem, endItem);
  }

  ngOnInit() {
   
    this.apiService.getNews().subscribe(data => {
      console.log(data)

      this.newsRecent = data.filter(it => {
        if(it.newsCategoryId != 1 && it.active)
          return it
      })
      this.newsPressRelease = data.filter(it => {
        if(it.newsCategoryId == 1 && it.active)
          return it
      })
      this.returnNewsRecent = this.newsRecent.slice(0, 9);
      this.returnNewsPress = this.newsPressRelease.slice(0, 9);
      //Press Releases
    })

  }

}
